import React from 'react';
import Configurator from '../../../model/configurator/Configurator';

export default class Field extends React.Component {

    onTabFocus = e => {
        Configurator.getInstance().onFieldTabFocus(this, e)
    }

    /**
     * Changes value of this field in the store.
     * @param {any} newValue
     */
    updateStoreValue(newValue) {
        if (this.props.field) {
            this.props.field.setValue(newValue)
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.renderField()}
            </React.Fragment>
        )
    }

    renderField() {
        throw new Error('NotImplementedError: Field#renderField')
    }

    /**
     * Generates a number that can be used to uniquely identify fields or inputs.
     * @return {String}
     */
    generateUniqueId() {
        return String(Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER) / 100))
    }
}